import React, { useEffect, useState } from 'react';
import Player from './Player';
import NPC from './NPC';
import Collectible from './Collectible';
import Dialog from './Dialog';
import Sidebar from './Sidebar';
import Minimap from './Minimap';
import { GameProvider } from '../contexts/GameContext';
const GameWorld = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [activeNpc, setActiveNpc] = useState(null);
  const [activeTab, setActiveTab] = useState('world');
  // NPC data
  const npcs = [{
    id: 1,
    x: 300,
    y: 200,
    name: 'Ada',
    role: 'AI Engineer',
    color: '#FF5733',
    dialog: ["Hello developer! I'm Ada, an AI Engineer.", 'Need help with machine learning algorithms?', 'I can guide you through implementing neural networks!']
  }, {
    id: 2,
    x: 600,
    y: 300,
    name: 'Turing',
    role: 'Code Reviewer',
    color: '#33A1FF',
    dialog: ["Greetings! I'm Turing, your friendly code reviewer.", 'I can help identify bugs and optimization opportunities.', 'Let me know if you need your code reviewed!']
  }, {
    id: 3,
    x: 400,
    y: 500,
    name: 'Nova',
    role: 'Job Recruiter',
    color: '#33FF57',
    dialog: ["Hi there! I'm Nova, a tech recruiter.", 'Looking for new opportunities?', 'Check out our job board for the latest openings!']
  }];
  // Collectible stars data
  const stars = [{
    id: 1,
    x: 200,
    y: 150
  }, {
    id: 2,
    x: 500,
    y: 250
  }, {
    id: 3,
    x: 350,
    y: 450
  }, {
    id: 4,
    x: 700,
    y: 350
  }, {
    id: 5,
    x: 150,
    y: 350
  }];
  // Handle NPC interaction
  const handleNpcInteraction = npc => {
    setActiveNpc(npc);
    setShowDialog(true);
  };
  // Close dialog
  const closeDialog = () => {
    setShowDialog(false);
    setActiveNpc(null);
  };
  // Handle tab change
  const handleTabChange = tab => {
    setActiveTab(tab);
  };
  return <GameProvider data-id="element-56">
      <div className="relative w-full h-full overflow-hidden bg-slate-900" data-id="element-57">
        {/* Game World Container */}
        <div className="absolute inset-0" style={{
        backgroundImage: `
            linear-gradient(rgba(26, 46, 68, 0.3) 1px, transparent 1px),
            linear-gradient(90deg, rgba(26, 46, 68, 0.3) 1px, transparent 1px)
          `,
        backgroundSize: '50px 50px'
      }} data-id="element-58">
          {/* Zones */}
          <div className="absolute rounded-full border-2 border-red-500/30 bg-red-500/10" style={{
          left: 200,
          top: 200,
          width: 200,
          height: 200,
          transform: 'translate(-50%, -50%)'
        }} data-id="element-59">
            <div className="absolute left-1/2 -top-8 transform -translate-x-1/2 text-white text-sm whitespace-nowrap" data-id="element-60">
              AI Zone
            </div>
          </div>
          <div className="absolute rounded-full border-2 border-blue-500/30 bg-blue-500/10" style={{
          left: 600,
          top: 300,
          width: 240,
          height: 240,
          transform: 'translate(-50%, -50%)'
        }} data-id="element-61">
            <div className="absolute left-1/2 -top-8 transform -translate-x-1/2 text-white text-sm whitespace-nowrap" data-id="element-62">
              Code Review
            </div>
          </div>
          <div className="absolute rounded-full border-2 border-green-500/30 bg-green-500/10" style={{
          left: 400,
          top: 500,
          width: 200,
          height: 200,
          transform: 'translate(-50%, -50%)'
        }} data-id="element-63">
            <div className="absolute left-1/2 -top-8 transform -translate-x-1/2 text-white text-sm whitespace-nowrap" data-id="element-64">
              Job Board
            </div>
          </div>
          <div className="absolute rounded-full border-2 border-yellow-500/30 bg-yellow-500/10" style={{
          left: 700,
          top: 150,
          width: 160,
          height: 160,
          transform: 'translate(-50%, -50%)'
        }} data-id="element-65">
            <div className="absolute left-1/2 -top-8 transform -translate-x-1/2 text-white text-sm whitespace-nowrap" data-id="element-66">
              Clan Hall
            </div>
          </div>
          {/* Collectible Stars */}
          {stars.map(star => <Collectible key={star.id} id={star.id} x={star.x} y={star.y} data-id="element-67" />)}
          {/* NPCs */}
          {npcs.map(npc => <NPC key={npc.id} x={npc.x} y={npc.y} name={npc.name} role={npc.role} color={npc.color} onInteract={() => handleNpcInteraction(npc)} data-id="element-68" />)}
          {/* Player */}
          <Player data-id="element-69" />
        </div>
        {/* Dialog */}
        {showDialog && activeNpc && <Dialog npc={activeNpc} onClose={closeDialog} data-id="element-70" />}
        {/* Minimap */}
        <Minimap npcs={npcs} data-id="element-71" />
        {/* Sidebar */}
        <Sidebar activeTab={activeTab} onTabChange={handleTabChange} data-id="element-72" />
      </div>
    </GameProvider>;
};
export default GameWorld;